import { periodFormat } from 'utils/common';

export const createReqBody = filter => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      action: filter.action[0] ? filter.action : '*',
      platform: filter.platform[0] ? filter.platform : '*',
      oldVersion: filter.oldVersion[0] ? filter.oldVersion : '*',
      newVersion: filter.newVersion[0] ? filter.newVersion : '*',
      updatedByName: filter.updatedByName[0] ? filter.updatedByName : '*',
      status: filter.status[0] ? filter.status : '*',
      _created_at: Array.isArray(filter._created_at)
        ? periodFormat({ startDate: null, endDate: null })
        : periodFormat(filter._created_at),
      isTestTenant: filter.isTestTenant
        ? filter.isTestTenant === 'True'
          ? true
          : false
        : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
